<template>
    <section class="sage-femme-dashboard" :class="{ 'tableau-de-bord main-section': enabled === true }">
        <p v-if="loading" role="status">Chargement du tableau de bord…</p>
        <div v-else-if="error" class="card p-4" role="alert">
            <h2 class="h5">{{ error }}</h2>
            <p>Vérifiez votre connexion et votre rôle actif, puis réessayez.</p>
            <div class="ui-modal-actions"><button type="button" class="btn btn-primary" @click="load">Réessayer</button></div>
        </div>
        <MedecinDashboard v-else-if="enabled === false" />
        <template v-else-if="enabled === true">
            <div class="row mb-4">
                <div class="col-lg-12">
                    <div class="body-header">
                        <div class="h-left animate animate-fadeInLeft">
                            <h1 class="p-title">Tableau de bord</h1>
                            <h2 class="p-subtitle text-grey">Bienvenue {{ user.name }}</h2>
                        </div>
                    </div>
                </div>
            </div>
            <ActiviteMedecin :tableau_api="api" mode_sage_femme />
            <ConsultationsMedecin :tableau_api="api" mode_sage_femme />
            <RendezVousMedecin :tableau_api="api" mode_sage_femme carte />
        </template>
    </section>
</template>

<script>
import api from './api'
import MedecinDashboard from '@/views/tableau-de-bord/dashboard-medecin'
import ActiviteMedecin from '@/views/tableau-de-bord/dashboard-medecin/activite-medecin'
import ConsultationsMedecin from '@/views/tableau-de-bord/dashboard-medecin/consultations-medecin'
import RendezVousMedecin from '@/views/tableau-de-bord/dashboard-medecin/rendez-vous-medecin'

export default {
    name: 'SageFemmeDashboard',
    components: { MedecinDashboard, ActiviteMedecin, ConsultationsMedecin, RendezVousMedecin },
    data: () => ({ api, enabled: null, loading: true, error: '', sequence: 0 }),
    computed: { user() { return this.$store.getters.authInfo || {} } },
    mounted() { this.load() },
    beforeDestroy() { this.sequence++ },
    methods: {
        async load() {
            const sequence = ++this.sequence
            this.loading = true
            this.enabled = null
            this.error = ''
            try {
                const response = await api.disponibilite()
                if (sequence !== this.sequence || this._isDestroyed) return
                if (!response || typeof response.enabled !== 'boolean') throw new Error('Réponse inattendue')
                this.enabled = response.enabled
            } catch (error) {
                if (sequence !== this.sequence || this._isDestroyed) return
                this.error = error && error.response && error.response.status === 403
                    ? 'Accès sage-femme refusé' : 'Tableau sage-femme indisponible'
            } finally {
                if (sequence === this.sequence && !this._isDestroyed) this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.sage-femme-dashboard { min-width: 0; color: var(--ui-text, #172033); }
.sage-femme-dashboard header p { color: var(--ui-text-secondary, #273449); }
</style>
